export const ComposerLoadingSkeleton = () => {
  return (
    <div className="p-3 pt-0">
      <div className="flex bg-surface flex-col min-h-[2rem] sm:min-h-[6rem] max-h-[30rem] gap-y-2 sm:gap-y-3 shadow-base border border-line-subdued px-3 py-2 rounded-base">
        <div className="shrink-0">
          <div className="h-full relative flex-col flex flex-1 min-h-[60px] max-h-[15rem]"></div>
        </div>
        <div className="flex justify-between items-center">
          <div className="shrink-0 flex items-center gap-x-1">
            <div className="w-8 h-8 bg-surface-subdued rounded-base" />
            <div className="w-8 h-8 bg-surface-subdued rounded-base" />
            <div className="w-8 h-8 bg-surface-subdued rounded-base" />
            <div className="w-8 h-8 bg-surface-subdued rounded-base" />
          </div>
          <div className="w-10 h-10 bg-surface-subdued rounded-base" />
        </div>
      </div>
    </div>
  )
}
